export default __webpack_public_path__ + "static/media/promo-bulk-deactivation.66d6e1a6.csv";